import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { hasPreviewModeProject, isUserFromEligibleCountry, isRlTrialOrigin } from '../../../utils/free-trial'
import styles from './FreeTrialBanner.module.css'

const StartFreeTrialAlert = ({ userCategory, productId, liveSites = [], onOpenFreeTrialModal }) => {
  const [show, setShow] = useState(true)

  const isInPreviewMode = hasPreviewModeProject(liveSites)

  const isB2BUser = userCategory === 'B2B'
  const isB2CUser = userCategory === 'B2C'
  const isFromEligibleCountry = isUserFromEligibleCountry() || isRlTrialOrigin()

  const shouldShowForB2B =
    isB2BUser &&
    !productId &&
    localStorage.getItem('b2bFreeTrialAlertClosed') !== 'true' &&
    localStorage.getItem('hasCompletedFreeTrial') !== 'true'

  const shouldShowForB2C =
    isB2CUser &&
    isFromEligibleCountry &&
    !productId &&
    localStorage.getItem('hasUsedFreeTrial') !== 'true' &&
    localStorage.getItem('hasCompletedFreeTrial') !== 'true'

  if (isInPreviewMode || !userCategory || (!shouldShowForB2B && !shouldShowForB2C)) {
    return null
  }

  const handleCloseAlert = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (isB2BUser) {
      localStorage.setItem('b2bFreeTrialAlertClosed', 'true')
    }
    // B2C users: don't set anything in localStorage when closing
    setShow(false)
  }

  const handleOpenFreeTrialModal = () => {
    const planType = isB2CUser ? 'solo' : 'pro'
    if (onOpenFreeTrialModal) {
      onOpenFreeTrialModal(planType)
    }
  }
  if (!show) return null

  return (
    <div className={styles.bannerContainer} onClick={handleOpenFreeTrialModal}>
      <div className={styles.bannerContent}>
        <button className={styles.closeButton} onClick={handleCloseAlert}>
          <img src="/assets/icons/cancel_white.svg" height="15" width="15" alt="cancel" />
        </button>

        <div className={styles.contentWrapper}>
          <div className={styles.iconSection}>
            <img
              src="/assets/icons/gift.svg"
              width="24"
              height="24"
              alt="Pro Trial"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </div>
          <div className={styles.textSection}>
            <h4 className={styles.title}>Start your free {isB2CUser ? 'Solo' : 'Pro'} Trial ✨</h4>
            <p className={styles.subtitle}>Access all {isB2CUser ? 'Solo' : 'Pro'} features for free for 7 days</p>
          </div>

          <div className={styles.buttonSection}>
            <Button
              variant="outline-light"
              className={styles.startTrialButton}
              data-testid="FreeTrialBanner-button-start"
            >
              Start for free
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StartFreeTrialAlert
